<div class="row">
  <div class="col-lg-6">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 images" id="Imagen_Error_404">
          <div>
            <img src="./assets/img/404.png" alt="Error 404" title="Error 404" class="image">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 html m-auto py-5 mb-5" id="Texto_gracias_error_404">
          <div class="content">
            <div>
              <p class="h1 text-white">404</p>
            </div>
            <div>
              <p class="h2 text-white mb-3">¡Página no encontrada!</p>
            </div>
            <div>
              <p class="h4 text-white">La página solicitada no ha sido encontrada.</p>
            </div>
            <div>
              <p class="h4 text-white">En este momento estamos trabajando para brindarte la mejor información.</p>
            </div>
          </div>
        </div>
        <div class="button col-lg-12"><a href="/" id="Button_error" class="button-orange mb-5">Regresá
            al Home</a>
        </div>
      </div>
    </div>
  </div>
</div>
